import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Youtube, Clock, MapPin } from "lucide-react";
import { ACADEMY, NAV_LINKS } from "../../lib/constants";

export default function Footer() {
  return (
    <footer className="bg-purple text-[#F6F4EE] relative overflow-hidden" data-testid="site-footer">
      <div className="rb-container pt-20 pb-10">
        {/* Big brand */}
        <div className="border-b border-[rgba(212,175,55,0.18)] pb-12 flex flex-col sm:flex-row sm:items-center gap-8">
          <img src="/rythmbara-logo.png" alt="Rythmbara Dance Academy" className="h-32 w-32 md:h-40 md:w-40 rounded-full shrink-0" />
          <div>
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Rythm<span className="gold-gradient-text">bara</span>
            </h2>
            <p className="mt-4 max-w-md text-[#F6F4EE]/70 text-base leading-relaxed">
              Where passion meets performance through dance. Nurturing artists in classical &amp; western forms under {ACADEMY.master}.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 py-12">
          <div>
            <p className="overline text-gold mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-[#F6F4EE]/75 hover:text-gold transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline text-gold mb-5">Contact</p>
            <ul className="space-y-3 text-[#F6F4EE]/75">
              <li>
                <a href={`tel:${ACADEMY.phoneRaw}`} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-gold" /> {ACADEMY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${ACADEMY.email}`} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-gold" /> {ACADEMY.email}
                </a>
              </li>
              <li>
                <a href={ACADEMY.mapLink} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-gold transition-colors" data-testid="footer-address">
                  <MapPin className="h-4 w-4 text-gold mt-1 shrink-0" /> <span className="leading-relaxed">{ACADEMY.address}</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline text-gold mb-5">Timings</p>
            <ul className="space-y-3 text-[#F6F4EE]/75">
              <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-gold" /> Morning: {ACADEMY.hours.morning}</li>
              <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-gold" /> Evening: {ACADEMY.hours.evening}</li>
            </ul>
          </div>

          <div>
            <p className="overline text-gold mb-5">Follow</p>
            <div className="flex gap-3">
              <a href={ACADEMY.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"
                 className="grid h-11 w-11 place-items-center border border-[rgba(212,175,55,0.35)] hover:bg-gold hover:text-[#1A0F2E] transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={ACADEMY.youtubeUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" aria-label="YouTube"
                 className="grid h-11 w-11 place-items-center border border-[rgba(212,175,55,0.35)] hover:bg-gold hover:text-[#1A0F2E] transition-colors duration-300">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
            <p className="mt-4 text-sm text-[#F6F4EE]/55">@{ACADEMY.instagram}</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-[rgba(212,175,55,0.18)] text-sm text-[#F6F4EE]/55">
          <p>© {new Date().getFullYear()} Rythmbara Dance Academy. All rights reserved.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
